var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"hp-card-6"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h5',{staticClass:"mb-32"},[_vm._v("Earnings")])]),_c('b-col',{attrs:{"cols":"12"}},[_c('apexchart',{attrs:{"options":_vm.options,"series":_vm.series,"type":"donut","height":"350","legend":"legend"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }